<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	import uploadFile from './uploadFile/index.vue'
	import uploadResult from './uploadResult/index.vue'
	import voucherDetail from './voucherDetail/index.vue'
	export default {
		name: 'subLeger',
		components: {
			uploadFile,
			uploadResult,
			voucherDetail
		},
		data: function() {
			return {
				headlist: getdata().headlist,
				chooseindex: 0
			};
		},
		created() {
		},
		methods: {
			forchooseindex(e) {
				this.chooseindex = e
			}
		}
	};
</script>


<style scoped lang="less">
	@import url("./index.less");
</style>
